/**
 * Default-filter logic for the action-center / notifications page.
 *
 * The "default to the logged-in advisor" behavior (4C1T-81) lives here so it
 * can be unit-tested without rendering the full component tree. The
 * `null` sentinel for `urlPrimaryAdvisorIds` means "the URL didn't say
 * anything"; that's what triggers the default. An empty array means the user
 * explicitly chose "show alerts for every advisor".
 */

type Advisor = {
  readonly id: string;
};

export type ResolveEffectivePrimaryAdvisorIdsArgs = {
  readonly showPrimaryAdvisorFilter: boolean;
  readonly urlPrimaryAdvisorIds: readonly string[] | null;
  readonly currentUserId: string | null;
  readonly primaryAdvisorOptions: readonly Advisor[];
  readonly defaultToCurrentUser?: boolean;
};

export function resolveEffectivePrimaryAdvisorIds({
  showPrimaryAdvisorFilter,
  urlPrimaryAdvisorIds,
  currentUserId,
  primaryAdvisorOptions,
  defaultToCurrentUser = true,
}: ResolveEffectivePrimaryAdvisorIdsArgs): readonly string[] {
  if (!showPrimaryAdvisorFilter) return [];
  if (urlPrimaryAdvisorIds !== null) return urlPrimaryAdvisorIds;
  if (!defaultToCurrentUser) return [];
  if (currentUserId === null || currentUserId === '') return [];
  const currentUserInOptions = primaryAdvisorOptions.some((opt) => opt.id === currentUserId);
  if (currentUserInOptions) return [currentUserId];
  return [];
}
